import React, { FC } from "react";

import { TransactionsProvider } from "./TransactionsContext";

const AppProvider: FC = ({ children }) => <TransactionsProvider>{children}</TransactionsProvider>;

export default AppProvider;
